// src/features/patientDTO/patientInfoSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import {
  InsuranceSerializer,
  InsuranceEtcBaseSerializer,
} from "@/types/insurance"
import { fetchInsuranceGs } from "@core/api/insuranceEtcApi"

interface InsurancePayload {
  insurances: InsuranceSerializer[] | []
  // insurance: InsuranceExtendSerializer | null
  insuranceGs: InsuranceEtcBaseSerializer[] | []
  insuranceG: InsuranceEtcBaseSerializer | null
  loading: boolean
  error: string | null
}

const initialState: InsurancePayload = {
  insurances: [],
  // insurance: null,
  insuranceGs: [],
  insuranceG: null,
  loading: false,
  error: null,
}

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    setInsurances(state, action: PayloadAction<InsuranceSerializer[]>) {
      state.insurances = action.payload
    },
    // setInsurance(
    //   state,
    //   action: PayloadAction<Partial<InsuranceExtendSerializer>>
    // ) {
    //   state.insurance = { ...state.insurance, ...action.payload }
    // },
    setInsuranceGs(state, action: PayloadAction<InsuranceEtcBaseSerializer[]>) {
      state.insuranceGs = action.payload
    },
    setInsuranceG(
      state,
      action: PayloadAction<Partial<InsuranceEtcBaseSerializer>>
    ) {
      state.insuranceG = { ...state.insuranceG, ...action.payload }
    },
    clearInsurances(state) {
      state.insurances = []
    },
    // clearInsurance(state) {
    //   state.insurance = null
    // },
    clearInsuranceGs(state) {
      state.insuranceGs = []
    },
    clearInsuranceG(state) {
      state.insuranceG = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchInsuranceGs.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchInsuranceGs.fulfilled, (state, action) => {
        state.loading = false
        state.insuranceGs = action.payload
      })
      .addCase(fetchInsuranceGs.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "알 수 없는 오류 발생"
      })

    // fetchPatient 관련 처리
    // Add any extra reducers if needed
  },
})

export const {
  setInsurances,
  // setInsurance,
  setInsuranceGs,
  setInsuranceG,
  clearInsurances,
  // clearInsurance,
  clearInsuranceGs,
  clearInsuranceG,
  setLoading,
  setError,
} = insuranceSlice.actions

export default insuranceSlice.reducer
